// React
import React, {Component} from 'react';
// Material
import {FormControl, ListSubheader, MenuItem, Select} from '@material-ui/core';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// Styles
import {withStyles} from '@material-ui/core/styles';
import '../../styles.scss';

const useStyles = {
    formControl: {
        maxWidth: (props) => props.maxWidth ? props.maxWidth : '100%'
    },
    inputLabel: {
        color: '#565671',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        display: 'ruby',
        textAlign: 'left',
        paddingBottom: '5px'
    }
}

class SelectGrouping extends Component {
    handleOnSelect = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const {onSelect, iteration} = this.props;

        onSelect(e.target.value, iteration);
    }

    renderSelectGroup = (item) => {
        const {value, type, t} = this.props;
        const items = item.items.map((it, i) => {
            var set_value = value ? it[value] : it;
            switch (type) {
                case 'select_project':
                    return <MenuItem key={i} value={it.id}>
                        {it.sandbox &&
                        <div className={"sandbox_selector"}>
                            <span>{it.name}</span>
                            <span className={"sandbox_label"}>sandbox</span>
                        </div>}
                        {!it.active &&
                        <div className={"soft_delete_selector"}>
                            <span>{it.name}</span>
                            <span className={"soft_delete_label"}>{t(`card.content.project.selector_deleted`)}</span>
                        </div>}
                        {!it.sandbox && it.active && <span>{it.name}</span>}
                    </MenuItem>
                default:
                    return (
                        <MenuItem key={i} value={set_value}>
                            <span className={"event"}>{set_value}</span>
                        </MenuItem>
                    )
            }
        });
        return items.length > 0 ? [<ListSubheader>{this.renderGroupName(item.group_name)}</ListSubheader>, items] : null;
    };

    renderGroupName = (group_name) => {
        const {type, t} = this.props;
        switch (type) {
            case 'select_project':
                return t(`card.content.project.selector_group.${group_name}`)
            default:
                return group_name;
        }
    }

    render() {
        const {valueSelected, items, placeholder, disabled, className, classes, id} = this.props;
        return (
            <FormControl className={`platform_select_grouping ${className ?? 'select_primary'} ${classes.formControl}`}>
                <Select
                    id={id}
                    disabled={disabled}
                    className={className ?? 'select_primary'}
                    value={valueSelected}
                    onChange={(e) => this.handleOnSelect(e)}
                    renderValue={(str) => {
                        if (!str && placeholder || str.length === 0 && placeholder) {
                            return <span className={"ellipsis"}>{placeholder}</span>
                        } else {
                            return <span className={"ellipsis"}>{str}</span>
                        }
                    }}
                    MenuProps={{
                        popoverclasses: className ?? 'select_primary',
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        style: {
                            maxHeight: 120 * 4.5,
                            width: '20ch',
                        }
                    }}
                    IconComponent={disabled ? false : ExpandMoreIcon}
                    inputProps={{'aria-label': 'Without label'}}
                >
                    <MenuItem disabled value="">
                        <em>{placeholder}</em>
                    </MenuItem>
                    {
                        items?.length > 0 ?
                            items.map(item => this.renderSelectGroup(item))
                            : <MenuItem disabled value={0}>{"-"}</MenuItem>
                    }
                </Select>
            </FormControl>
        );
    }
}

export default withStyles(useStyles)(SelectGrouping);
